export const INTEGRATION_SECTIONS = [
  { key: 'overview', path: '/integrations/overview' },
  { key: 'ai', path: '/integrations/ai' },
  { key: 'scanners', path: '/integrations/scanners' },
  { key: 'google-cloud', path: '/integrations/google-cloud' },
]

export const SCANNER_SECTIONS = ['greenbone', 'zap', 'nuclei']
export const GCP_SECTIONS = ['connection', 'inventory', 'history', 'sources']

export function sectionIsActive(pathname, path) {
  return pathname === path || pathname.startsWith(`${path}/`)
}

export function buildResourceListPath(integrationId, { limit = 50, kind = '', search = '', cursor = '' } = {}) {
  const params = new URLSearchParams()
  params.set('limit', String(limit))
  if (kind) params.set('kind', kind)
  if (search) params.set('search', search)
  if (cursor) params.set('cursor', cursor)
  return `/${integrationId}/resources?${params.toString()}`
}
